import * as React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ControlBarIconContainer } from "./widgets";
import {
    SendParticipantCommandMutation,
    SendParticipantCommandMutationVariables,
    SendParticipantCommandDocument,
} from "./queries-chatto.generated";
import { CommandType } from "@/api";
import { useCurrentMeeting } from "../contexts/currentMeeting";
import { useParticipantStatus } from "conference/components/meeting-page/room/participantStatus";
import { useChattoHttpMutation } from "conference/apollo-client/chatto/hooks";
import { FormattedMessage } from "react-intl";

const RaiseHandButton = () => {
    const currentMeeting = useCurrentMeeting();

    const [sendCommand] = useChattoHttpMutation<
        SendParticipantCommandMutation,
        SendParticipantCommandMutationVariables
    >(SendParticipantCommandDocument);

    const status = useParticipantStatus(currentMeeting.selfUri);

    const toggleHand = async () => {
        await sendCommand({
            variables: {
                command: {
                    roomId: currentMeeting.chatRoomId,
                    type: status.handRaised ? CommandType.LowerHand : CommandType.RaiseHand,
                    initiator: currentMeeting.selfUri,
                    target: currentMeeting.selfUri,
                },
            },
        });
    };

    return (
        <Tooltip
            title={
                <FormattedMessage
                    id="meetingPage.room.raiseHand"
                    defaultMessage="{raised, plural, =0 {Raise} other {Lower}} your hand"
                    values={{ raised: status.handRaised ? 1 : 0 }}
                />
            }
            arrow
        >
            <IconButton onClick={toggleHand} color={status.handRaised ? "primary" : "default"} size="large">
                <ControlBarIconContainer>
                    <FontAwesomeIcon icon="hand-paper" />
                </ControlBarIconContainer>
            </IconButton>
        </Tooltip>
    );
};

export default RaiseHandButton;
